import { useEffect, useState } from "react";
import { Button, Card, Box, Typography, Tooltip, DialogActions } from "@mui/material";
import MessageError from "../../../../messages/messageError";
import api from "../../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import MessageSuccess from "../../../../messages/messageSuccess";
import { useNavigate } from "react-router-dom";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import ButtonLeft from "../../../../utils/buttonLeft";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";

const styles = {
  containerCardesService: {
    marginTop: '2rem',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '2rem',
  },

  root: {
    textAlign: 'center',
    width: '20%',
    minHeight: 100,
    minWidth: 100,
    border: '1px solid #85287e',
    borderRadius: 10,
    transition: '.5s',
  }
}


export default function EncaminhaExpedienteAreas({ expediente, setUpdate }) {
  const classes = styles;
  const [messageSuccess, setMessageSuccess] = useState("");
  const [messageError, setErrorMessage] = useState("");
  const [status, setStatus] = useState('Director Geral');
  const [load, setLoad] = useState(false);
  const user = useSelector((state) => state.account.user);
  const [areaSelected, setAreaSelected] = useState('');
  const [observacao, setObservacao] = useState('');
  const dispatch = useDispatch()
  const navigate = useNavigate()


  useEffect(() => {
    setObservacao(`Encaminahado para ${areaSelected}`);
    setStatus(areaSelected);

    if (expediente?.status === 'Análise') {
      setAreaSelected('Director Geral');
    }

  }, [areaSelected])



  async function changeStatusExpediente() {
    setLoad(true);
    setErrorMessage("");
    setMessageSuccess("");

    await api.patch("/expediente/change-status", {
      status,
      expedienteId: expediente._id,
      userId: user._id,
      observacao: observacao
    })
      .then((response) => {
        // console.log(response)
        setLoad(false);
        setMessageSuccess(response.data.msg);
        setUpdate(response.data);

        dispatch({
          type: 'alert',
          payload: { alert: `O expediente foi encminhado para ${status}` },
        });

        window.setTimeout(() => {
          navigate('/admin/dadg/expediente/area/Análise')
        }, 5000);
      })
      .catch((error) => {
        // console.log(error)
        // setErrorMessage(error.response.data.message);
        setLoad(false);
      });
  }

  const CardAreas = ({ icone, nomeService, title }) => {
    return (
      <Tooltip title={title}>
        <CardActionArea
          onClick={() => setAreaSelected(nomeService)}
          style={(nomeService === areaSelected || (nomeService === expediente?.status && !areaSelected)) ? { ...classes.root, background: '#b1b7ea', transition: '.5s', transform: 'scale(1.2)' } : classes.root}>
          <CardContent>
            <img src={icone} alt={''} style={{ height: 50 }} />
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <Typography color="textPrimary" variant="subtitle1" style={{ lineHeight: 1, fontSize: 15 }}>
              {nomeService}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Tooltip>
    )
  }


  return (
    <Card style={{ padding: 25, maxWidth: 800, margin: 'auto' }}>
      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}

      <HeaderGestorConfigs
        title={`SELECIONAR DESTINO PARA ENCAMINHADO O EXPEDIENTE  ${expediente?.numero}`}
      />
      <br />

      {expediente?.status === 'Análise' ?
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CardAreas icone={'/icones/expediente/directorGeral.svg'} nomeService={'Director Geral'} title={'Este expediente será encaminhado para o Director Geral'} />
          </div>
        </>
        :
        <Box style={classes.containerCardesService}>
          <CardAreas icone={''} nomeService={'DGA SE'} title={''} />
          <CardAreas icone={''} nomeService={'DGS SA'} title={''} />
          <CardAreas icone={''} nomeService={'DADG'} title={'Departamento Apoio ao Director Geral'} />
          <CardAreas icone={''} nomeService={'DCITMS'} title={'Departamento de Comunição e Inovação Tecnológica e Modernização de Serviços '} />
          <CardAreas icone={''} nomeService={'DASG'} title={'Departamento Administração e Serviços Gerais'} />
          <CardAreas icone={''} nomeService={'DCQMTS'} title={'Departamento Controlo de qualidade de Medicamentos e Tecnologias de Saúde'} />
          <CardAreas icone={''} nomeService={'DFTEC'} title={'Departamento Farmacovigilância, Tecnovigilância e Ensaios Clínicos'} />
          <CardAreas icone={''} nomeService={'DLIF'} title={'Departamento Licenciamento e Inspecção Farmacêutica'} />
          <CardAreas icone={''} nomeService={'DMTS'} title={'Departamento Medicamentos e Tecnologias de Saúde'} />
          {/* <CardAreas icone={''} nomeService={'Serviços Gerais'} /> */}
          <CardAreas icone={''} nomeService={'Indeferido'} title={'Para expedientes que não serão respondidos'} />
        </Box>
      }

      {!areaSelected &&
         <DialogActions>
          <Button onClick={() => navigate(-1)} color="error" size="small">Cancelar</Button>
        </DialogActions>
      }

      <br />
      {areaSelected && (areaSelected !== expediente?.status) && (
        <>
          <FazerObservacoes
            setObs={setObservacao}
            obs={observacao}
          // titulo="(Descreve aqui os motivos)"
          />
          <ButtonLeft
            title={'Encaminhar'}
            funcao={changeStatusExpediente}
            load={load}
            disabled={load || !areaSelected}
          >
            <Button onClick={() => navigate(-1)} color="error" size="small">Cancelar</Button>
          </ButtonLeft>
        </>
      )}

    </Card>
  );
}
